module.exports = {"TXTCLI_Contact_Support":{"id":"TXTCLI_Contact_Support","defaultMessage":"Свържи се с поддръжка","track":"Contact Support"}}